module.exports = __webpack_public_path__ + "img/generate_schedule.dd68cee6.png";